import { Component, input } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-feature-card',
  imports: [MatCardModule, MatIconModule],
  templateUrl: './feature-card.component.html',
  styleUrl: './feature-card.component.scss',
})
export class FeatureCardComponent {
  readonly icon = input<string>('');
  readonly title = input.required<string>();
  readonly description = input.required<string>();
  readonly variant = input<'default' | 'highlight'>('default');
}
